import { IUsersContextData } from 'interfaces/commons/IContext';
import { createContext } from 'react';

export const UsersContext = createContext<IUsersContextData>({} as IUsersContextData);
